var render = function render(){var _vm=this,_c=_vm._self._c;return _c('anonymous-template',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c(_vm.currentView,{tag:"component",attrs:{"verificationData":_vm.verificationData,"merchants":_vm.merchants},on:{"submit":_vm.handleSubmit,"editIdentifier":_vm.editIdentifier}}),_c('site-footer')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }